let rascunho = null

function clonar (valor) {
  return JSON.parse(JSON.stringify(valor))
}

export function salvarRascunhoCadastro (idEdital, estado) {
  if (!idEdital) {
    return
  }

  rascunho = {
    idEdital: String(idEdital),
    estado: clonar(estado)
  }
}

export function obterRascunhoCadastro (idEdital) {
  if (!rascunho || !idEdital) {
    return null
  }

  if (rascunho.idEdital !== String(idEdital)) {
    return null
  }

  return clonar(rascunho.estado)
}

export function temRascunhoCadastro (idEdital) {
  if (!rascunho || !idEdital) {
    return false
  }

  return rascunho.idEdital === String(idEdital)
}

export function limparRascunhoCadastro (idEdital) {
  if (!rascunho) {
    return
  }

  if (!idEdital || rascunho.idEdital === String(idEdital)) {
    rascunho = null
  }
}
